import script from "./MsgSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./MsgSetting.vue?vue&type=script&setup=true&lang=js"

import "./MsgSetting.vue?vue&type=style&index=0&id=21b560c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b560c0"]])

export default __exports__